<template>
	<div>

		<!-- <div>
			<table-filter :filters="filters" @onFilter="onFilterLocal" @onClear="clearFilters"></table-filter>
		</div> -->

		<FiltersTable titleButton="Obtener órdenes" searchPlaceholder="Buscar por 'Órden ML'"  @onSearch="onSearch"/>

		<VxTable 
		
			stripe
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage">
			
			<template slot="thead">
				<vs-th>Órden ML</vs-th>
				<vs-th>Comprador</vs-th>
				<vs-th>DNI Facturación</vs-th>
				<vs-th v-if="mode === 'flex'" style="min-width: 160px">Producto</vs-th>
				<vs-th>Valor Compra</vs-th>
				<vs-th v-if="mode === 'flex'" style="min-width: 140px">Destino</vs-th>
				<vs-th style="min-width: 100px">Fecha</vs-th>
				<!-- "Actualizada" y "Modo" salen del panel Flex: la solapa ya filtra por Flex, y esos dos lugares se usan para Producto y Destino. -->
				<vs-th v-if="mode !== 'flex'" style="min-width: 130px">Actualizada</vs-th>
				<vs-th v-if="mode !== 'flex'" style="min-width: 130px">Modo</vs-th>
				<vs-th>Acción</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{ data[indextr].id }}
						<br v-if="data[indextr].pack_id" />
						<small v-if="data[indextr].pack_id" class="order-pack-id">N° compra: {{ data[indextr].pack_id }}</small>
					</vs-td>
					<vs-td>
						Cuenta: <em>{{tr.buyer.first_name}} {{tr.buyer.last_name}} ({{tr.buyer.nickname}}).</em> <br>
						<template v-if="tr.shipment_data && tr.shipment_data.receiver_address">
							Recibe:  <em>{{tr.shipment_data.receiver_address.receiver_name}} </em>
						</template>
					</vs-td>
					<vs-td>
						<!-- {{tr.buyer.billing_info.doc_number}} -->
					</vs-td>
					<vs-td v-if="mode === 'flex'">
						{{ productSummary(tr) }}
					</vs-td>
					<vs-td>
						$ {{tr.total_amount}}
					</vs-td>
					<vs-td v-if="mode === 'flex'">
						{{ destinationLabel(tr) }}
					</vs-td>
					<vs-td>
						{{ data[indextr].date_created | formatDate }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{ data[indextr].last_updated | formatDateFromNow }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{ orderModeLabel(tr) }}
					</vs-td>
					<vs-td>
						<!-- <vs-button type="border" size="small" color="primary" class="mr-2" 
							@click="openPopupDetalle(data[indextr])">
							<feather-icon icon="SearchIcon" svgClasses="h-2 w-2"/>
							Detalle
						</vs-button> -->
						 <feather-icon class="order-action" @click="openDetails(tr)" title="Ver el detalle" icon="EyeIcon" svgClasses="h-5 w-5 mx-5 cursor-pointer" />
					</vs-td>
				</vs-tr>
			</template>

		</VxTable>
		<div v-if="showDetailModal">
        	<OrderDetails :orderDetail="orderDetail"  @orderDetail="handleOrderDetails"/>
    	</div>

	</div>
</template>

<script>
// Extraer: 
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS 
import _ from 'lodash'// ya esta improtado en archivo local pero si no lo improto aca da errores aveces

import moment from 'moment'
import { orderModeLabel, productSummary, destinationLabel } from "../../utils/orderLabels";
moment.locale('es')

import axios from 'axios';
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue"


export default {
	components: {
		OrderDetails,
		FiltersTable
	},
	computed:{
		authUser() {
      			return this.$store.state.authUser
    }
	},
	props: {
		// ME1 o Flex — lo inyectan las rutas (ver router.js); default ME1.
		mode: { type: String, default: 'me1' }
	},
	data(){
		return {
			orders: [],
			ordersPreserved:[], // used when reseting local filtering
			totalItems: 0,
			selected: [], // Los items seleccionados con el checkbox 
			
			// Popup (detalle & proccesar)
			popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
			popupOrderShipmentInfo: null,

			// Popup - detalle
			popupDetalleActive: false,

			filters:[        
				{ // OK
					id: 3,
					description: 'Por Fecha',
					obj_key: 'order.date_created',
					obj_key_local: 'order.date_created',
					type: 'date',
					input_type: 'text',
					from: '',
					to: '',
					//source: 'meli_call',
				},
				{ // OK
					id: 4,
					description: 'Por # de Órden',
					obj_key: 'q',
					obj_key_local: 'order.id',
					type: 'input',
					input_type: 'text',
					//source: 'meli_call',
				},
				{
					id: 5,
					description: 'Por DNI',
					obj_key: 'order.buyer.billing_info.doc_number',// Meli no lo toma
					obj_key_local: 'dni',
					type: 'input',
					input_type: 'text',
					//source: 'after_meli'
				},
				{ // OK
					id: 6,
					description: 'Por Nombre',
					obj_key: 'q',
					obj_key_local: 'name',
					type: 'input',
					input_type: 'text',
				},
				{
					id: 7,
					description: 'Por Localidad',
					obj_key: 'locality',
					obj_key_local: 'locality',
					type: 'input',
					input_type: 'text',
				}
			],

			filtersSelected: [],

			showDetailModal: false,
      		orderDetail: {},


		}
	},

	filters : {
		formatDate(rawDate){
			return moment(rawDate).format("D-M-Y");
		},
		formatDateFromNow(rawDate){
			return moment(rawDate).fromNow();
		},
	},


	watch: {
		// Las rutas ME1 y Flex montan ESTE MISMO componente: Vue reutiliza la instancia y no vuelve a ejecutar mounted().
		mode() {
			this.page = 1;
			this.orders = [];
			this.ordersPreserved = [];
			this.totalItems = 0;
			this.selected = [];
			this.loadOrders(1);
		}
	},
	mounted() {
		this.loadOrders();		
	},

	methods: {
		orderModeLabel,
		productSummary,
		destinationLabel,

		loadOrders(page = 1) {
			this.$vs.loading();

			this.filtersSelected['page'] = page;
			this.filtersSelected['mode'] = this.mode;

			try {
				const filtersSelected = this.filtersSelected;
				const query = Object.keys(filtersSelected)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
				.join('&');

				axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-archived?' + query)
				.then(orders => {

					const body = orders.data.body || [];
					const paging = orders.data.paging || {};

					// Si `body` no viniera, antes la grilla se quedaba con las filas anteriores.
					this.orders = body;
					this.ordersPreserved = body;

					// `total` puede ser 0 en una busqueda sin resultados: con un `if` el paginador seguia en la consulta previa.
					this.totalItems = paging.total || 0;
				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					this.$vs.loading.close();
				});

			} catch (e) {
				console.log(e);
				this.$vs.loading.close(); 
			}
		},

		handleChangePage (page) {
			this.loadOrders(page)
		},

		openDetails(tr) {
			this.orderDetail = tr;
			this.showDetailModal = true;
		},
		handleOrderDetails() {
			this.orderDetail = null;
			this.showDetailModal = false;
		},
		onSearch(value) {
			this.filtersSelected = value;
			this.loadOrders(1);
		}

	}
}
</script>